import { BASE_URL } from '../../config/config';

export const eventService = {
  getUpcomingEvents: async (categoryId, page = 1, limit = 10) => {
    try {
      const url = new URL(`${BASE_URL}/events/get-upcoming-events`);
      url.searchParams.append('page', page);
      url.searchParams.append('limit', limit);
      if (categoryId) {
        url.searchParams.append('category', categoryId);
      }

      const response = await fetch(url.toString(), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to fetch events');
      }

      return data;
    } catch (error) {
      throw error;
    }
  },

  getOrganizerProfile: async (organizerId) => {
    try {
      const url = new URL(`${BASE_URL}/events/get-organizer-profile`);
      url.searchParams.append('organizerId', organizerId);

      const response = await fetch(url.toString(), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to fetch organizer profile');
      }

      return data;
    } catch (error) {
      throw error;
    }
  }
};
